import { BaseService } from '../../BaseService';

class DashboardUserRatingService extends BaseService {
  getUserRatings(page = 1, size = 10) {
    return this.get('', {
      params: {
        page,
        size,
      },
    });
  }
  getUserRating(ratingId) {
    return this.get(String(ratingId));
  }

  putUserRating(ratingId, data) {
    return this.put(String(ratingId), data);
  }

  deleteUserRating(ratingId) {
    return this.delete(String(ratingId));
  }
}

export default new DashboardUserRatingService('dashboard/user/ratings');
